module.exports = __webpack_public_path__ + "img/otopack250-inactive.f8320058.svg";